<template>
  <div v-if="status" style="padding: 30px;">
    <v-card v-if="paymentStatus" style="padding: 30px;">
      <v-btn
        v-if="paymentStatus.Status !== status"
        color="orange"
      >
        {{paymentStatus.Status}} / {{status}}
      </v-btn>
      <div v-if="status === 'rejected'">
        <h2>{{paymentStatus.Concept}}</h2>
        <h2>{{paymentStatus.Amount}}</h2>
        <h2>{{paymentStatus.LMD}}</h2>
        <h1 style="color:red;">Pago rechazado por el banco</h1>
      </div>
      <div v-else-if="status === 'paid'">
        <h2>{{paymentStatus.Concept}}</h2>
        <h2>{{paymentStatus.Amount}}</h2>
        <h2>{{paymentStatus.LMD}}</h2>
        <h1 
          v-if="paymentStatus.Status === status"
          style="color:green;"
        >Pago realizado con éxito</h1>
      </div>
      <div v-else>
        <h2>{{paymentStatus.Concept}}</h2>
        <h2>{{paymentStatus.Amount}}</h2>
        <h2>{{paymentStatus.LMD}}</h2>
        <h1 style="color:orange;">Pago {{status}}</h1>
      </div>
    </v-card>
  </div>
  <div v-else>
    <div v-if="info" style="padding: 50px 0 10px 50px;">
      <h2><span style="color: gray;">Concepto:</span> {{info.Concept}}</h2>
      <h2><span style="color: gray;">Importe:</span> {{info.Amount}}</h2>
      <h2 v-if="info.Status === 'paid'"><span style="color: blue;">Pago no disponible</span></h2>
    </div>

    <iframe id="targetIframe" style="border:0;display:none;width:100%;height:calc(100vh);" />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    info: null,
    paymentStatus: null,
  }),
  computed: {
    status () {
      return this.$route.params.status
    },
    id () {
      return this.$route.params.id
    },
    test () {
      return this.$route.query.test ? true : false
    },
  },
  mounted () {
    if (this.status) this.prepareStatus()
    if (!this.status) this.preparePay()
  },
  methods: {
    async prepareStatus () {
      try {
        if (!this.id) return
        const url = `${process.env.VUE_APP_ENV === 'production' ? 'https://cm-payments-api.dview.es' : 'http://dtouch.local:3807' }/v1/public/payments/status`
        this.paymentStatus = await new Promise((resolve, reject) => axios.post(url, { id: this.id })
          .then(response => {
            if (response.data && response.data.Amount) {
              let aux = response.data.Amount.toString().padStart(3, "0")
              let b = aux.substring(aux.length -2, aux.length)
              let a = aux.substring(0, aux.length -2)

              response.data.Amount = `${a}.${b} €`
              response.data.LMD = response.data.LMD.split('.').shift().split('T').join(' ')
            }
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            alert('error')
          }))
      } catch (error) {
        alert('Error')
        console.log(error)
      }
    },
    async preparePay () {
      try {
        if (!this.id) return
        let url = `${process.env.VUE_APP_ENV === 'production' ? 'https://cm-payments-api.dview.es' : 'http://dtouch.local:3807' }/v1/public/payments/status`
        this.info = await new Promise((resolve, reject) => axios.post(url, { id: this.id })
          .then(response => {
            if (response.data && response.data.Amount) {
              let aux = response.data.Amount.toString().padStart(3, "0")
              let b = aux.substring(aux.length -2, aux.length)
              let a = aux.substring(0, aux.length -2)

              response.data.Amount = `${a}.${b} €`
              response.data.LMD = response.data.LMD.split('.').shift().split('T').join(' ')
            }
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            alert('error')
          }))
        if (this.info.Status === 'paid') return
        url = `${process.env.VUE_APP_ENV === 'production' ? 'https://cm-payments-api.dview.es' : 'http://dtouch.local:3807' }/v1/public/payments/addon-payments-json`
        const body = await new Promise((resolve, reject) => axios.post(url, { id: this.id })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            alert('error')
          }))

        if (this.test) RealexHpp.setHppUrl('https://hpp.sandbox.addonpayments.com/pay')
        else RealexHpp.setHppUrl('https://hpp.addonpayments.com/pay')
        RealexHpp.embedded.init(
            "autoload",
            "targetIframe",
            `https://www.dtouch.es/assets/addon-payments/response-cm-payments.php?locale=${this.locale}`,
            body
        )
        document.body.classList.add('loaded')
      } catch (error) {
        alert('Error')
        console.log(error)
      }
    },
  }
}
</script>
